import React, { Component } from "react";
import { Container, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import s from "./styles.scss";
import { downloadProyectoAnualidad } from "../../../actions/comisionAnualidad";
import { ResumenClubDispatcher } from "../../../containers/comisionesAnualidad/resumenClub/ResumenClub.dispatcher";
import { ResumenClubStore } from "../../../containers/comisionesAnualidad/resumenClub/ResumenClub.store";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import { Inputs, Buttons, formConfig } from "./ResumenClub.form";
import {
  opcionesFormConfigBuilder,
  opcionesInitializer
} from "./ResumenClubFiltros.form";
import ResumenClubTable from "./ResumenClubTable";

interface Props extends ResumenClubStore, ResumenClubDispatcher, RouterProps {}

interface State {
  filtros: { [key: string]: boolean };
  downloading: boolean;
}

@Styled(s)
export default class ResumenClub extends Component<Props, State> {
  state: State = {
    filtros: {},
    downloading: false
  };

  async componentDidMount() {
    this.props.clearAnualidadProyecto();
    await this.props.getProyectosOptions();
  }

  componentDidUpdate(prevProps: Props) {
    const prev = prevProps.anualidadProyecto;
    const curr = this.props.anualidadProyecto;

    if (curr && curr !== prev) {
      this.setState({ filtros: opcionesInitializer(curr.periodosMensuales) });
    }
  }

  submit = async (values: { periodo: string; alcancesActuales: boolean }) => {
    this.props.clearAnualidadProyecto();

    const alcancesActuales = !!values.alcancesActuales;
    await this.props.getProyectoByPeriodo(values.periodo, alcancesActuales);
  };

  onFiltrosChange = (values: { [key: string]: boolean }) => {
    this.setState({ filtros: values });
  };

  onDownload = () => {
    const { anualidadProyecto } = this.props;

    if (!anualidadProyecto) {
      return;
    }

    this.setState({ downloading: true });
    downloadProyectoAnualidad(anualidadProyecto.periodoCarga, () => {
      this.setState({ downloading: false });
    });
  };

  render() {
    const {
      anualidadProyectosOptions,
      gettingAnualidadProyectosOptions,
      gettingAnualidadProyecto,
      anualidadProyecto
    } = this.props;

    const loading =
      gettingAnualidadProyectosOptions ||
      gettingAnualidadProyecto ||
      this.state.downloading;

    return (
      <Container>
        {/* Búsqueda por proyecto */}
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={gettingAnualidadProyecto}
          loading={loading}
        >
          <ISelectBuilder
            name="periodo"
            data={anualidadProyectosOptions || []}
          />
        </FormBuilder>

        {/* Opciones de presentación */}
        {anualidadProyecto && (
          <>
            <div style={{ margin: "0 -16px" }}>
              <p className="primaryTitle w-100 m-0">Opciones de presentación</p>
            </div>

            <FormBuilder
              key={anualidadProyecto.idCarga}
              config={opcionesFormConfigBuilder(
                anualidadProyecto.periodosMensuales
              )}
              init={opcionesInitializer(anualidadProyecto.periodosMensuales)}
              onChange={this.onFiltrosChange}
              loading={loading}
            />

            <div style={{ margin: "0 -15px" }}>
              <div className="text-right mb-3">
                <Button
                  color="outline-secondary"
                  size="sm"
                  onClick={this.onDownload}
                  disabled={loading}
                >
                  <FontAwesomeIcon icon={faFileCsv} className="mr-2" />
                  {this.state.downloading ? "Descargando..." : "Descargar CSV"}
                </Button>
              </div>

              {/* Tabla de resumen */}
              <ResumenClubTable
                proyecto={anualidadProyecto}
                filtros={this.state.filtros}
              />
            </div>
          </>
        )}
      </Container>
    );
  }
}
